import React from 'react';
import { DocumentAdd16, Download16, Time16 } from '@carbon/icons-react';
import { CompletionScreen } from 'components/PremiumWizard';

interface CompleteStepProps {
  enquiriesLodged?: number;
  isPostpay?: boolean;
  transactionReference?: string | null;
  onDownload: () => void;
  onMyEnquiries: () => void;
  onStartNew: () => void;
  isDownloadDisabled?: boolean;
  isDownloading?: boolean;
}

const CompleteStep: React.FC<CompleteStepProps> = ({
  enquiriesLodged = 0,
  isPostpay = false,
  transactionReference,
  onDownload,
  onMyEnquiries,
  onStartNew,
  isDownloadDisabled = false,
  isDownloading = false
}) => {
  const paymentStat = isPostpay
    ? {
        label: 'Payment',
        value: 'Invoice will be issued',
        valueClassName: 'completion-screen__stat-value--success'
      }
    : {
        label: 'Transaction reference',
        value: transactionReference?.trim() || '—',
        valueClassName: 'bel-complete-step__transaction-reference'
      };

  return (
    <CompletionScreen
      heading="Enquiries lodged successfully"
      statsRowClassName={!isPostpay ? 'expand' : undefined}
      stats={[
        { label: 'Enquiries lodged', value: String(enquiriesLodged) },
        paymentStat
      ]}
      primaryAction={{
        label: isDownloading
          ? 'Downloading...'
          : 'Download updated geospatial file',
        icon: Download16,
        onClick: onDownload,
        disabled: isDownloadDisabled || isDownloading
      }}
      outsideActions={[
        {
          label: 'Start new large area enquiries',
          icon: DocumentAdd16,
          onClick: onStartNew,
          kind: 'tertiary'
        },
        {
          label: 'My enquiries',
          icon: Time16,
          onClick: onMyEnquiries,
          kind: 'tertiary'
        }
      ]}
    />
  );
};

export default CompleteStep;
